import { getScreenBreakpoints } from './getScreenBreakpoints';

export { getScreenBreakpoints };
